var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import UserFeedback from '../components/UserFeedback';
import useListSchools from '../hooks/useListSchools';
import { addSalePoint, deleteSalePoint, listMySalePoints, } from '../utils/api/salePointApi';
import { deleteUserAccount, fetchUserProfile, updateUserProfile, } from '../utils/api/userAccountApi';
import { formatSchoolName, mergeSchools } from '../utils/salePoint/schoolUtil';
var buildFormState = function (profile) { return ({
    name: profile.name || '',
    phone: profile.phone || '',
    hideName: profile.hideName,
    hidePhone: profile.hidePhone,
    hasVipps: profile.hasVipps,
    schoolId: profile.schoolId ? String(profile.schoolId) : '',
}); };
var AddSalePointForm = function (_a) {
    var onSalePointAdded = _a.onSalePointAdded;
    var _b = React.useState(''), address = _b[0], setAddress = _b[1];
    var _c = React.useState(''), postalCode = _c[0], setPostalCode = _c[1];
    var _d = React.useState(false), isSaving = _d[0], setIsSaving = _d[1];
    var _e = React.useState(null), error = _e[0], setError = _e[1];
    var handleSubmit = function (event) {
        event.preventDefault();
        if (!address.trim()) {
            setError('Du må skrive inn en adresse');
            return;
        }
        if (!/^\d{4}$/.test(postalCode)) {
            setError('Postnummeret må bestå av fire siffer');
            return;
        }
        setError(null);
        setIsSaving(true);
        addSalePoint({ address: address.trim(), postalCode: postalCode })
            .then(function () {
            setAddress('');
            setPostalCode('');
            onSalePointAdded();
        })
            .catch(function (err) { return setError((err === null || err === void 0 ? void 0 : err.message) || 'Kunne ikke lagre salgsstedet. Prøv igjen.'); })
            .finally(function () { return setIsSaving(false); });
    };
    return React.createElement("form", { className: "vertical", onSubmit: handleSubmit },
        error && React.createElement("p", { role: "alert", className: "form-error" }, error),
        React.createElement("div", { className: "form-field" },
            React.createElement("label", { className: "field-label", htmlFor: "new_sale_point" }, "Adresse"),
            React.createElement("input", { id: "new_sale_point", name: "new_sale_point", type: "text", maxLength: 200, placeholder: "Olav Tryggvasons gate", required: true, value: address, disabled: isSaving, onChange: function (event) { return setAddress(event.target.value); } })),
        React.createElement("div", { className: "form-field" },
            React.createElement("label", { className: "field-label", htmlFor: "new_sale_point_zip" }, "Postnummer"),
            React.createElement("input", { id: "new_sale_point_zip", name: "new_sale_point_zip", type: "text", inputMode: "numeric", pattern: "[0-9]{4}", maxLength: 4, placeholder: "7000", required: true, value: postalCode, disabled: isSaving, onChange: function (event) { return setPostalCode(event.target.value); } })),
        React.createElement("button", { type: "submit", id: "add_sale_point", disabled: isSaving }, isSaving ? 'Legger til...' : 'Legg til salgssted'));
};
/**
 * "Innstillinger" — lets the signed-in user edit their
 * profile, study place and sale points, and delete their account.
 * */
var SettingsPage = function () {
    var schools = useListSchools().schools;
    var allSchools = mergeSchools(schools);
    var _a = React.useState(null), profile = _a[0], setProfile = _a[1];
    var _b = React.useState(null), formState = _b[0], setFormState = _b[1];
    var _c = React.useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = React.useState(false), isSaving = _d[0], setIsSaving = _d[1];
    var _e = React.useState(null), saveError = _e[0], setSaveError = _e[1];
    var _f = React.useState(false), isSaved = _f[0], setIsSaved = _f[1];
    var _g = React.useState([]), salePoints = _g[0], setSalePoints = _g[1];
    var _h = React.useState(false), isDeletingAccount = _h[0], setIsDeletingAccount = _h[1];
    var _j = React.useState(null), deleteError = _j[0], setDeleteError = _j[1];
    var reloadSalePoints = React.useCallback(function () {
        listMySalePoints()
            .then(function (nextSalePoints) { return setSalePoints(nextSalePoints || []); })
            .catch(function () { return setSalePoints([]); });
    }, []);
    React.useEffect(function () {
        var isMounted = true;
        fetchUserProfile()
            .then(function (nextProfile) {
            if (!isMounted) {
                return;
            }
            setProfile(nextProfile);
            setFormState(buildFormState(nextProfile));
        })
            .catch(function () {
            if (isMounted) {
                setSaveError('Kunne ikke hente innstillingene dine. Last siden på nytt for å prøve igjen.');
            }
        })
            .finally(function () {
            if (isMounted) {
                setIsLoading(false);
            }
        });
        return function () {
            isMounted = false;
        };
    }, []);
    React.useEffect(function () {
        reloadSalePoints();
    }, [reloadSalePoints]);
    var setField = function (field, value) {
        setFormState(function (current) {
            var _a;
            return (current ? __assign(__assign({}, current), (_a = {}, _a[field] = value, _a)) : current);
        });
    };
    var handleSave = function (event) {
        event.preventDefault();
        if (!formState) {
            return;
        }
        var patch = {
            name: formState.name.trim(),
            phone: formState.phone.trim() || null,
            schoolId: formState.schoolId ? Number(formState.schoolId) : null,
            hasVipps: formState.hasVipps,
            hideName: formState.hideName,
            hidePhone: formState.hidePhone,
        };
        setIsSaving(true);
        setSaveError(null);
        setIsSaved(false);
        updateUserProfile(patch)
            .then(function (nextProfile) {
            setProfile(nextProfile);
            setFormState(buildFormState(nextProfile));
            setIsSaved(true);
        })
            .catch(function (err) { return setSaveError((err === null || err === void 0 ? void 0 : err.message) || 'Kunne ikke lagre endringene. Prøv igjen.'); })
            .finally(function () { return setIsSaving(false); });
    };
    var removeSalePoint = function (salePoint) {
        deleteSalePoint(salePoint.id)
            .then(function () { return setSalePoints(function (current) { return current.filter(function (item) { return item.id !== salePoint.id; }); }); })
            .catch(function () { return setSaveError('Kunne ikke slette salgsstedet. Prøv igjen.'); });
    };
    var handleDeleteAccount = function () {
        if (!window.confirm('Slette brukerkontoen din? Alle annonsene og bokvarslingene dine blir slettet, '
            + 'og dette kan ikke angres.')) {
            return;
        }
        setIsDeletingAccount(true);
        setDeleteError(null);
        deleteUserAccount()
            .then(function () {
            window.location.href = '/';
        })
            .catch(function () {
            setDeleteError('Kunne ikke slette brukerkontoen din. Prøv igjen om litt.');
            setIsDeletingAccount(false);
        });
    };
    if (isLoading) {
        return React.createElement("div", { className: "main-content" },
            React.createElement("h1", null, "Innstillinger"),
            React.createElement("p", null, "Laster innstillingene dine..."));
    }
    if (!profile || !formState) {
        return React.createElement("div", { className: "main-content", role: "alert" },
            React.createElement("h1", null, "Innstillinger"),
            React.createElement("p", null, saveError || 'Kunne ikke hente innstillingene dine.'));
    }
    return React.createElement("div", { className: "main-content" },
        React.createElement("h1", null, "Innstillinger"),
        React.createElement("form", { method: "post", className: "pure-form vertical", onSubmit: handleSave },
            React.createElement("fieldset", { className: "vertical" },
                React.createElement("legend", null, "Brukerinformasjon"),
                React.createElement("label", { htmlFor: "settings_name" }, "Ditt navn:"),
                React.createElement("input", { type: "text", name: "name", id: "settings_name", maxLength: 100, value: formState.name, disabled: isSaving, onChange: function (event) { return setField('name', event.target.value); } }),
                React.createElement("label", { htmlFor: "hide_name", id: "hide_name_label", className: profile.hideSellerPage ? 'placeholder' : '' },
                    React.createElement("input", { type: "checkbox", name: "hide_name", id: "hide_name", checked: formState.hideName, disabled: isSaving, title: "Skjul ditt navn fra selgersiden din", onChange: function (event) { return setField('hideName', event.target.checked); } }),
                    "Skjul navn p\u00E5 selgersiden min"),
                React.createElement("label", { htmlFor: "settings_email" }, "Din e-postadresse:"),
                React.createElement("input", { type: "email", name: "email", id: "settings_email", value: profile.email, readOnly: true, disabled: true, title: "E-postadressen kan ikke endres" }),
                React.createElement("label", { htmlFor: "settings_phone" }, "Ditt telefonnummer:"),
                React.createElement("input", { type: "text", id: "settings_phone", name: "phone", maxLength: 12, value: formState.phone, disabled: isSaving, onChange: function (event) { return setField('phone', event.target.value); } }),
                React.createElement("label", { htmlFor: "hide_phone", id: "hide_phone_label", className: profile.hideSellerPage ? 'placeholder' : '' },
                    React.createElement("input", { type: "checkbox", name: "hide_phone", id: "hide_phone", checked: formState.hidePhone, disabled: isSaving, title: "Skjul ditt telefonnummer fra selgersiden din", onChange: function (event) { return setField('hidePhone', event.target.checked); } }),
                    "Skjul telefonnummer p\u00E5 selgersiden min")),
            React.createElement("fieldset", null,
                React.createElement("legend", null, "Betalingsinformasjon"),
                React.createElement("label", { htmlFor: "has_vipps", id: "has_vipps_label" },
                    React.createElement("input", { type: "checkbox", name: "has_vipps", id: "has_vipps", checked: formState.hasVipps, disabled: isSaving, title: "St\u00F8tter betaling gjennom Vipps", onChange: function (event) { return setField('hasVipps', event.target.checked); } }),
                    "St\u00F8tter betaling gjennom Vipps")),
            React.createElement("fieldset", null,
                React.createElement("legend", null, "Studiested"),
                React.createElement("label", { htmlFor: "school_id" }, "Ditt studiested:"),
                React.createElement("select", { name: "school_id", id: "school_id", value: formState.schoolId, disabled: isSaving, onChange: function (event) { return setField('schoolId', event.target.value); } },
                    React.createElement("option", { value: "" }, "Ingen studiested"),
                    allSchools.map(function (school) { return (React.createElement("option", { key: school.id, value: school.id }, formatSchoolName(school))); }))),
            React.createElement("div", { className: "horizontal" },
                React.createElement("fieldset", { className: "salepoint" },
                    React.createElement("legend", { className: "field_header study" }, "Salgssteder"),
                    React.createElement("table", { id: "address_table" },
                        React.createElement("tbody", null,
                            salePoints.map(function (salePoint) { return (React.createElement("tr", { key: salePoint.id, "data-id": salePoint.id },
                                React.createElement("td", { className: "name", title: salePoint.salePoint }, salePoint.salePoint),
                                React.createElement("td", null, salePoint.zipCodeId),
                                React.createElement("td", null, salePoint.city),
                                React.createElement("td", null,
                                    React.createElement("button", { type: "button", className: "delete", title: "Slett salgssted", onClick: function () { return removeSalePoint(salePoint); } },
                                        React.createElement("img", { src: "/static/img/deleteButton2.svg", alt: "Slett salgssted" }))))); }),
                            salePoints.length === 0 && React.createElement("tr", null,
                                React.createElement("td", { colSpan: 4 }, "Du har ingen lagrede salgssteder.")))),
                    React.createElement(AddSalePointForm, { onSalePointAdded: reloadSalePoints }))),
            saveError && React.createElement("p", { role: "alert", className: "form-error" }, saveError),
            isSaved && React.createElement(UserFeedback, { status: "success" },
                React.createElement("p", null, "Endringene dine har blitt lagret!")),
            React.createElement("button", { type: "submit", name: "btn_submit", value: "save_changes", id: "settings_save", disabled: isSaving }, isSaving ? 'Lagrer...' : 'Lagre endringer')),
        React.createElement("section", null,
            React.createElement("h2", { className: "dangerous" }, "Farlige handlinger"),
            deleteError && React.createElement("p", { role: "alert", className: "form-error" }, deleteError),
            React.createElement("button", { id: "btn_delete_user", type: "button", className: "dangerous", disabled: isDeletingAccount, onClick: handleDeleteAccount }, isDeletingAccount ? 'Sletter brukerkonto...' : 'Slett brukerkonto')));
};
export default SettingsPage;
